import { createPrefixer } from '@mews-commander/utils';
import { MODULE_NAME } from './constants';

export default createPrefixer(MODULE_NAME);
